/* Keep the custom mobile header's dropdown links acting as tabs. */
document.addEventListener('click', function (event) {
  if (!window.matchMedia('(max-width: 767px)').matches || !document.body.classList.contains('is-open-newmenu')) return;
  var link = event.target.closest('#NavStandard a[data-top-link]');
  if (!link) return;
  var item = link.parentElement;
  var dropdown = item.querySelector(':scope > [data-hover-disclosure]');
  if (!dropdown) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  document.querySelectorAll('#NavStandard [data-hover-disclosure-toggle]').forEach(function (sibling) {
    var active = sibling === item;
    sibling.classList.toggle('is-visible', active);
    sibling.setAttribute('aria-expanded', String(active));
  });
  item.classList.add('is-visible');
  item.setAttribute('aria-expanded', 'true');
}, true);
